<template>
  <div>
    <tplheader></tplheader>
    <tplLeftPanel></tplLeftPanel>
    <div id="fixed-top-menu-outer" class="fixed-top-menu-outer">
      <div class="fixed-top-menu">
        <div class="pull-right">
          <ajaxLoaderButton :onClick="savePreCheck" iconclass="fa fa-save" label="Ment" v-model="is_save"/>
          <router-link v-if="form.user.id != 0" class="btn btn-primary" :to="{ path: '/card/edit', query: { id: 0, owner_id: form.user.id } }"><i class="fa fa-plus"></i>Új kártya</router-link>
        </div>
      </div>
    </div>
    <div id="main-panel" class="main-panel">
      <div class="content-panel">
        <ul class="breadcrumb">
          <li>Kezdőőoldal</li>
          <li>Kártyabirtokosok</li>
          <li>Kártyabirtokos</li>
        </ul>
        <div class="page-title">
          <h1><i class="material-icons">chevron_right</i>Kártyabirtokos</h1>
        </div>
        <div class="content-panel-top-btn-group">
          <ajaxLoaderButton :onClick="savePreCheck" iconclass="fa fa-save" label="Ment" v-model="is_save"/>
          <router-link v-if="form.user.id != 0" class="btn btn-primary" :to="{ path: '/card/edit', query: { id: 0, owner_id: form.user.id } }"><i class="fa fa-plus"></i>Új kártya</router-link>
        </div>
        <div class="panel">
          <div class="panel-heading">
            <h4>Kártyabirtokos</h4>
          </div>
          <form enctype="multipart/form-data">
            <div class="panel-body">
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div class="panel-sub-heading"><h4>Adatok</h4></div>
                    <button style="margin-bottom:20px" v-on:click="showFillPopup" class="btn btn-white" type="button"><i class="fa fa-pencil"></i>Kitöltés segéd</button>
                    <select2ajax url="shibuser/search" :change="shibUserChange" id="dn" label="Címtár felhasználó" v-bind:errors="errors" name="dn" v-model="form.shib_users"></select2ajax>
                    <select2ajax v-if="showADSelectbox()" url="aduser/search" :change="ADUserChange" id="ad_user" label="AD felhasználó" v-bind:errors="errors" name="ad_user" v-model="form.ad_users"></select2ajax>
                    <inputbox inputCheck="name" id="name" label="Név" v-bind:errors="errors" name="username" v-model="form.user.name"></inputbox>
                    <inputbox id="email" label="Email" v-bind:errors="errors" name="email" v-model="form.user.email"></inputbox>
                    <inputbox inputCheck="phone" id="phone" label="Telefon" v-bind:errors="errors" name="phone" v-model="form.user.phone"></inputbox>
                    <inputbox inputCheck="neptuncode" maxlength="6" id="neptun_code" label="Neptun kód" v-bind:errors="errors" name="neptun_code" v-model="form.user.neptun_code"></inputbox>
                    <inputbox inputCheck="orgware" id="orgware_id" label="Orgware ID" v-bind:errors="errors" name="orgware_id" v-model="form.user.orgware_id"></inputbox>
                    <!--<inputbox id="ad_object_sid" label="AD sid" v-bind:errors="errors" name="ad_object_sid" v-model="form.user.ad_object_sid"></inputbox>-->
                    <!--<inputbox id="ad_username" label="AD felhasználónév" v-bind:errors="errors" name="ad_username" v-model="form.user.ad_username"></inputbox>-->
                    <combobox id="id_doc_type_id" label="Azonosító okmány típusa" v-bind:errors="errors" name="id_doc_type_id" v-model="form.id_doc_type"></combobox>
                    <inputbox inputCheck="personalDocumentID" id="id_doc_id" label="Azonosító okmány száma" v-bind:errors="errors" name="id_doc_id" v-model="form.user.id_doc_id"></inputbox>
                    <!--<inputbox id="password" label="Jelszó" v-bind:errors="errors" name="password" v-model="form.user.password"></inputbox>
                    <inputbox id="password_" label="Jelszó újra" v-bind:errors="errors" name="password_" v-model="form.user.password_"></inputbox>-->

                    <div class="row">
                      <div class="col-xs-3">
                        <inputbox disabled="1" id="account_expires" label="AD lejárati idő" name="account_expires" v-model="form.user.account_expires"></inputbox>
                      </div>
                      <div v-if="this.form.user.account_expires_btn"  class="col-xs-9">
                        <button v-on:click="modifyAccountExpires" style="margin-top:15px;" class="btn btn-white" type="button"><i class="fa fa-clock-o"></i>Idő hosszabbítás 1 évvel</button>
                      </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-8 col-md-8 col-lg-8">
                  <div v-bind:style="{width:video_div_w+'px', height:video_div_h+'px'}" style="position:relative; border: 1px solid #E5E9EC; margin-bottom: 15px;">
                    <i style="position:absolute; left:50%; top:50%; font-size:40px; color:#d8dbde; margin:-30px 0px 0px -30px;" class="fa fa-camera"></i>
                    <canvas v-bind:width="video_canvas_w" v-bind:height="video_canvas_h" style="position:absolute; left:-10000px;"></canvas>
                    <video style="position:absolute;" width="100%" height="100%" autoplay></video>
                  </div>
                  <div style="width: 100%; text-align: center;">
                    <button :disabled="!takePictureEnabled" v-if="cameraOn" v-on:click="takePicture" class="btn btn-primary" type="button"><i class="fa fa-picture-o"></i>Kép készítése</button>
                    <button v-on:click="turnOnOffCamera" class="btn btn-primary" type="button"><i class="fa fa-camera"></i>{{ cameraTurnOnOffBtnTitle }}</button>
                    <button id="upload_photo_btn" v-on:click="uploadPhotoClick" class="btn btn-primary" type="button"><i class="fa fa-upload"></i>Fotó feltöltése</button>
                    <input accept="image/*" id="upload_file" v-on:change="uploadPhoto" type="file" style="position:absolute;left:-10000px;">
                  </div>
                </div>
                <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                  <div style="position:relative; width:250px; min-height:300px; border: 1px solid #E5E9EC; margin-bottom: 15px;">
                    <i style="position:absolute; left:50%; top:50%; font-size:40px; color:#d8dbde; margin:-30px 0px 0px -30px;" class="fa fa-image"></i>
                    <img style="position:absolute; width: 100%; height: auto" v-bind:src="previewImage">
                  </div>
                </div>
              </div>

              <div class="panel-sub-heading"><h4>Kártyák</h4></div>
              <div v-if="cardsShow" class="row">
                <div class="col-xs-12">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Kártyaszám</th>
                        <th>Létrehozva</th>
                        <th>Rf ID</th>
                        <th>Jogok</th>
                        <th style="text-align:center">Státusz</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="card in form.user.cards">
                        <td>{{card.id}}</td>
                        <td>{{card.card_number}}</td>
                        <td>{{card.created}}</td>
                        <td>{{card.rf_id}}</td>
                        <td>
                          <table v-show="cardRulesShow(card)" class="table table-bordered">
                            <thead>
                              <tr>
                                <th>Megnevezés</th>
                                <th>Érvényesség</th>
                                <th style="text-align:center">Engedélyezve</th>
                                <th style="text-align:center">Elsődleges</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="rule in card.rules">
                                <td>{{rule.name}}</td>
                                <td>{{rule.valid_from}} - {{rule.valid_to}}</td>
                                <td style="text-align:center"><i v-if="rule.public" class="fa fa-check"></i><i v-if="!rule.public" class="fa fa-times"></i></td>
                                <td style="text-align:center"><i v-if="rule.primaryc" class="fa fa-check"></i><i v-if="!rule.primaryc" class="fa fa-times"></i></td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td style="text-align:center">{{card.status}}</td>
                        <td>
                          <ul v-if="cardEditButtonShow(card.rules)" class="icon-list">
                            <li class="dropdown"><a class="dropdown-toggle" href="javascript:void(0)"><i class="fa fa-gear"></i></a>
                              <ul class="dropdown-menu">
                                <li class="dropdown-header">Opciók</li>
                                <li><router-link :to="{ path: '/card/edit/', query: { id: card.id }}"><i class="fa fa-pencil-square-o"></i>Módosít</router-link></li>
                              </ul>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-else class="row">
                <div class="col-xs-12">
                  Nem található kártya.
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div id="cropmodal" class="modal-content no-overlay" v-bind:style="{width: cropPopupWidth + 'px'}" v-if="crop_popup">
      <div class="modal-header">
        <button v-on:click="hideCropPopupClick" type="button" class="close"><span aria-hidden="true">×</span></button>
        <h4 class="modal-title">Vágás</h4>
      </div>
      <div class="modal-body">
        <img alt="" id="crop-image" v-bind:src="form.user.new_photo">
      </div>
      <div class="modal-footer">
        <button v-on:click="hideCropPopupClick" class="btn btn-large" type="button">Bezár</button>
        <button v-on:click="crop" class="btn btn-primary btn-large" type="button">Mentés</button>
      </div>
    </div>

    <fillPopup v-if="form.user.id == 0 && this.fill_popup" :fillUserData="fillUserData" :hidepopup="hideFillPopup"></fillPopup>
    <fillPopupModify @onBtnClick="fillPopupBtnClick" :user="form.user" v-if="form.user.id != 0 && this.fill_popup" :hidepopup="hideFillPopup"></fillPopupModify>

    <comparePopup :userdata="form.user" v-if="this.compare_popup" :setUserID="setUserID" :fillUserData="fillUserData" :saveCardOwner="save" :hidepopup="hideComparePopup"></comparePopup>
  </div>
</template>
<script>
import Vue from 'vue';

import tplheader from './tpl_header.vue';
import tplLeftPanel from './tpl_leftpanel.vue';

Vue.component('comparePopup', {
  props: ['hidepopup','userdata','saveCardOwner','fillUserData','setUserID'],
  data: function() {
    return {
      items: []
    };
  },
  template: '<div style="width: 900px" class="modal-content no-overlay">\
        <div class="modal-header">\
          <button v-on:click="hide" type="button" class="close"><span aria-hidden="true">×</span></button>\
          <h4 class="modal-title">Összehasonlítás</h4>\
        </div>\
        <div class="modal-body">\
          <table v-if="items.length > 0" class="table table-bordered">\
            <thead>\
              <tr>\
                <th></th>\
                <th>Név</th>\
                <th>Email</th>\
                <th>Telefonszám</th>\
                <th>Neptun kód</th>\
                <th>OrgwareID</th>\
                <th>Címtár fnév</th>\
              </tr>\
            </thead>\
            <tbody>\
              <tr v-for="item in items">\
                <td><button v-on:click="getCardOwnerByID(item.id)" class="btn btn-white small only-icon" type="button"><i class="fa fa-floppy-o"></i></button>\</td>\
                <td v-bind:class="{eq: inArray(\'name\', item.equal)}">{{item.name}}</td>\
                <td v-bind:class="{eq: inArray(\'email\', item.equal)}">{{item.email}}</td>\
                <td v-bind:class="{eq: inArray(\'phone\', item.equal)}">{{item.phone}}</td>\
                <td v-bind:class="{eq: inArray(\'neptun_code\', item.equal)}">{{item.neptun_code}}</td>\
                <td v-bind:class="{eq: inArray(\'orgware_id\', item.equal)}">{{item.orgware_id}}</td>\
                <td>{{item.up_username}}</td>\
              </tr>\
            </tbody>\
          </table>\
          <div v-else>Nem található hasonló felhasználó.</div>\
        </div>\
        <div class="modal-footer">\
          <button v-on:click="hide" class="btn btn-large" type="button">Bezár</button>\
          <button v-on:click="newUserSave" class="btn btn-primary btn-large" type="button">Új kártyabirtokos ment</button>\
        </div>\
      </div>\
    </div>',
  computed: {

  },
  mounted: function() {
    var _this = this;

    this.$root.ajax('card_owner/compare', {
      data: this.userdata,
      method: 'POST',
      success: function(response) {
        _this.items = response.items;
      }
    });
  },
  methods: {
    inArray: function(needle, haystack) {
        var length = haystack.length;
        for(var i = 0; i < length; i++) {
            if(haystack[i] == needle) return true;
        }
        return false;
    },
    hide: function() {
      this.hidepopup();
    },
    newUserSave: function() {
      this.hide();
      this.saveCardOwner(0);
    },
    getCardOwnerByID: function(id) {
      var _this = this;

      this.$root.ajax('/card_owner/get/' + id, {
        success: function(response) {
          if (response.cardowner != undefined) {
            _this.setUserID(response.cardowner.id);
            _this.saveCardOwner(0);
          }
        }
      });
    }
  }
});

Vue.component('fillPopup', {
  props: ['hidepopup','fillUserData'],
  data: function() {
    return {
      shib_user_items: {
       items: [],
       selected: 0
      },
      neptun_code_items: {
       items: [],
       selected: 0
      },
      orgware_items: {
       items: [],
       selected: 0
      },
      mid: '',
      photo: '',
      id_doc_type_id: 1,
      shib: {
        name: '',
        email: '',
        phone: '',
        neptun_code: '',
        orgware_id: '',
        id_doc_id: ''
      },
      neptun: {
        name: '',
        email: '',
        phone: '',
        neptun_code: '',
        orgware_id: '',
        id_doc_id: ''
      },
      orgware: {
        name: '',
        email: '',
        phone: '',
        neptun_code: '',
        orgware_id: '',
        id_doc_id: ''
      },
      sel_name: "shib",
      sel_email: "shib",
      sel_phone: "shib",
      sel_neptun_code: "shib",
      sel_orgware_id: "shib",
      sel_id_doc_id: "shib"
    };
  },
  template: `<div style="width: 900px" class="modal-content no-overlay kitoltes-seged">
        <div class="modal-header">
          <button v-on:click="hide" type="button" class="close"><span aria-hidden="true">×</span></button>
          <h4 class="modal-title">Kitöltés segéd</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-xs-12">
              <select2ajax url="fill_popup_search/shib" :change="shibUserChange" label="Címtár felhasználó" id="fp_shib_users" name="fp_shib_users" v-model="shib_user_items"></select2ajax>
            </div>
            <div class="col-xs-12">
              <select2ajax url="fill_popup_search/neptun" :change="neptunCodeChange" label="Neptun kód" id="fp_neptun_code" name="fp_neptun_code" v-model="neptun_code_items"></select2ajax>
            </div>
            <div class="col-xs-12">
              <select2ajax url="fill_popup_search/orgware" :change="orgwareChange" label="Orgware ID" id="fp_orgware" name="fp_orgware" v-model="orgware_items"></select2ajax>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-4" style="background-color: #fdfdfd">
              <div class="row">
                <div class="col-xs-12">
                  <div class="panel-sub-heading">
                    <h4>Címtár</h4>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="radio">
                      <input id="sel_name_1" v-model="sel_name" type="radio" value="shib">
                      <label for="sel_name_1"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Név" v-model="shib.name"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="radio">
                      <input id="sel_email_1" v-model="sel_email" type="radio" value="shib">
                      <label for="sel_email_1"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Email" v-model="shib.email"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="radio">
                      <input id="sel_phone_1" v-model="sel_phone" type="radio" value="shib">
                      <label for="sel_phone_1"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Telefon" v-model="shib.phone"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="radio">
                      <input id="sel_neptun_code_1" v-model="sel_neptun_code" type="radio" value="shib">
                      <label for="sel_neptun_code_1"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Neptun kód" v-model="shib.neptun_code"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="radio">
                      <input id="sel_orgware_id_1" v-model="sel_orgware_id" type="radio" value="shib">
                      <label for="sel_orgware_id_1"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Orgware" v-model="shib.orgware_id"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="radio">
                      <input id="sel_id_doc_id_1" v-model="sel_id_doc_id" type="radio" value="shib">
                      <label for="sel_id_doc_id_1"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Szem. ig. szám" v-model="shib.id_doc_id"></inputbox>
                </div>
              </div>
              <button style="margin-bottom:20px" class="btn btn-white" v-on:click="insert('shib')" type="button"><i class="fa fa-level-down"></i>Adatok kitöltése</button>
            </div>
            <div class="col-xs-4" style="background-color: #f8f9fa">
              <div class="row">
                <div class="col-xs-12">
                  <div class="panel-sub-heading">
                    <h4>Neptun</h4>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="radio">
                      <input id="sel_name_2" v-model="sel_name" type="radio" value="neptun">
                      <label for="sel_name_2"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Név" v-model="neptun.name"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="radio">
                      <input id="sel_email_2" v-model="sel_email" type="radio" value="neptun">
                      <label for="sel_email_2"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Email" v-model="neptun.email"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="radio">
                      <input id="sel_phone_2" v-model="sel_phone" type="radio" value="neptun">
                      <label for="sel_phone_2"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Telefon" v-model="neptun.phone"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="radio">
                      <input id="sel_neptun_code_2" v-model="sel_neptun_code" type="radio" value="neptun">
                      <label for="sel_neptun_code_2"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Neptun kód" v-model="neptun.neptun_code"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="radio">
                      <input id="sel_orgware_id_2" v-model="sel_orgware_id" type="radio" value="neptun">
                      <label for="sel_orgware_id_2"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Orgware" v-model="neptun.orgware_id"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="radio">
                      <input id="sel_id_doc_id_2" v-model="sel_id_doc_id" type="radio" value="neptun">
                      <label for="sel_id_doc_id_2"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Szem. ig. szám" v-model="neptun.id_doc_id"></inputbox>
                </div>
              </div>
              <button style="margin-bottom:20px" class="btn btn-white" v-on:click="insert('neptun')" type="button"><i class="fa fa-level-down"></i>Adatok kitöltése</button>
            </div>
            <div class="col-xs-4" style="background-color: #fdfdfd">
              <div class="row">
                <div class="col-xs-12">
                  <div class="panel-sub-heading">
                    <h4>AD</h4>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="radio">
                      <input id="sel_name_3" v-model="sel_name" type="radio" value="orgware">
                      <label for="sel_name_3"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Név" v-model="orgware.name"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="radio">
                      <input id="sel_email_3" v-model="sel_email" type="radio" value="orgware">
                      <label for="sel_email_3"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Email" v-model="orgware.email"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="radio">
                      <input id="sel_phone_3" v-model="sel_phone" type="radio" value="orgware">
                      <label for="sel_phone_3"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Telefon" v-model="orgware.phone"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="radio">
                      <input id="sel_neptun_code_3" v-model="sel_neptun_code" type="radio" value="orgware">
                      <label for="sel_neptun_code_3"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Neptun kód" v-model="orgware.neptun_code"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="radio">
                      <input id="sel_orgware_id_3" v-model="sel_orgware_id" type="radio" value="orgware">
                      <label for="sel_orgware_id_3"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Orgware" v-model="orgware.orgware_id"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="radio">
                      <input id="sel_id_doc_id_3" v-model="sel_id_doc_id" type="radio" value="orgware">
                      <label for="sel_id_doc_id_3"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Szem. ig. szám" v-model="orgware.id_doc_id"></inputbox>
                </div>
              </div>
              <button style="margin-bottom:20px" class="btn btn-white" v-on:click="insert('orgware')" type="button"><i class="fa fa-level-down"></i>Adatok kitöltése</button>
          </div>
        </div>
        <div class="modal-footer">
          <button v-on:click="hide" class="btn btn-large" type="button">Bezár</button>
          <button v-on:click="insert('')" class="btn btn-primary btn-large" type="button"><i class="fa fa-level-down"></i>Kiválasztott adatok kitöltése</button>
        </div>
      </div>
    </div>`,
  computed: {
  },
  mounted: function() {
    var _this = this;

  },
  methods: {
    shibUserChange: function(data) {
      var d = JSON.parse(this.shib_user_items.selected);
      this.shib.name = d.name;
      this.shib.email = d.email;
      this.shib.phone = '';
      this.shib.neptun_code = d.neptuncode;
      this.shib.orgware_id = d.orgware_id;
      this.shib.id_doc_id = d.idcardnumber;
      this.mid = d.mid;
      this.photo = d.photo;
    },
    neptunCodeChange: function() {
      var d = JSON.parse(this.neptun_code_items.selected);
      this.neptun.name = d.name;
      this.neptun.email = d.email;
      this.neptun.phone = d.phone;
      this.neptun.neptun_code = d.neptuncode;
      this.neptun.orgware_id = d.orgware_id;
      this.neptun.id_doc_id = d.idcardnumber;
    },
    orgwareChange: function() {
      var d = JSON.parse(this.orgware_items.selected);
      this.orgware.name = d.name;
      this.orgware.email = d.email;
      this.orgware.phone = d.phone;
      this.orgware.neptun_code = d.neptuncode;
      this.orgware.orgware_id = d.orgware_id;
      this.orgware.id_doc_id = '';
    },
    insert: function(s) {
      if (s == '')
        this.fillUserData(this[this.sel_name].name, this[this.sel_email].email, this[this.sel_phone].phone, this[this.sel_neptun_code].neptun_code, this[this.sel_orgware_id].orgware_id, this[this.sel_id_doc_id].id_doc_id, this.id_doc_type_id, this.mid, this.photo);
      else
        this.fillUserData(this[s].name, this[s].email, this[s].phone, this[s].neptun_code, this[s].orgware_id, this[s].id_doc_id, this.id_doc_type_id, this.mid, this.photo);

      this.hide();
    },
    hide: function() {
      this.hidepopup();
    }
  }
});

Vue.component('fillPopupModify', {
  props: ['hidepopup','fillUserData','user'],
  data: function() {
    return {
      loading: false,
      shib: {
        name: '',
        email: '',
        phone: '',
        neptun_code: '',
        orgware_id: '',
        id_doc_id: ''
      },
      neptun: {
        name: '',
        email: '',
        phone: '',
        neptun_code: '',
        orgware_id: '',
        id_doc_id: ''
      },
      orgware: {
        name: '',
        email: '',
        phone: '',
        neptun_code: '',
        orgware_id: '',
        id_doc_id: ''
      },
      sel_name: "",
      sel_email: "",
      sel_phone: "",
      sel_neptun_code: "",
      sel_orgware_id: "",
      sel_id_doc_id: ""
    };
  },
  template: `<div style="width: 900px" class="modal-content no-overlay kitoltes-seged">
        <div class="modal-header">
          <button v-on:click="hide" type="button" class="close"><span aria-hidden="true">×</span></button>
          <h4 class="modal-title">Kitöltés segéd</h4>
        </div>
        <div v-if="!loading" class="modal-body">
          <div class="row">
            <div class="col-xs-4" style="background-color: #fdfdfd">
              <div class="row">
                <div class="col-xs-12">
                  <div class="panel-sub-heading">
                    <h4>Címtár</h4>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="checkbox" style="margin: 0px">
                      <input :disabled="shib.name == ''" id="sel_name_1" v-model="sel_name" type="checkbox" true-value="shib" false-value="">
                      <label for="sel_name_1"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Név" v-model="shib.name"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="checkbox" style="margin: 0px">
                      <input :disabled="shib.email == ''" id="sel_email_1" v-model="sel_email" type="checkbox" true-value="shib" false-value="">
                      <label for="sel_email_1"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Email" v-model="shib.email"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="checkbox" style="margin: 0px">
                      <input :disabled="shib.phone == ''" id="sel_phone_1" v-model="sel_phone" type="checkbox" true-value="shib" false-value="">
                      <label for="sel_phone_1"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Telefon" v-model="shib.phone"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="checkbox" style="margin: 0px">
                      <input :disabled="shib.neptun_code == ''" id="sel_neptun_code_1" v-model="sel_neptun_code" type="checkbox" true-value="shib" false-value="">
                      <label for="sel_neptun_code_1"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Neptun kód" v-model="shib.neptun_code"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="checkbox" style="margin: 0px">
                      <input :disabled="shib.orgware_id == ''" id="sel_orgware_id_1" v-model="sel_orgware_id" type="checkbox" true-value="shib" false-value="">
                      <label for="sel_orgware_id_1"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Orgware" v-model="shib.orgware_id"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="checkbox" style="margin: 0px">
                      <input :disabled="shib.id_doc_id == ''" id="sel_id_doc_id_1" v-model="sel_id_doc_id" type="checkbox" true-value="shib" false-value="">
                      <label for="sel_id_doc_id_1"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Szem. ig. szám" v-model="shib.id_doc_id"></inputbox>
                </div>
              </div>
            </div>
            <div class="col-xs-4" style="background-color: #f8f9fa">
              <div class="row">
                <div class="col-xs-12">
                  <div class="panel-sub-heading">
                    <h4>Neptun</h4>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="checkbox" style="margin: 0px">
                      <input :disabled="neptun.name == ''" id="sel_name_2" v-model="sel_name" type="checkbox" true-value="neptun" false-value="">
                      <label for="sel_name_2"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Név" v-model="neptun.name"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="checkbox" style="margin: 0px">
                      <input :disabled="neptun.email == ''" id="sel_email_2" v-model="sel_email" type="checkbox" true-value="neptun" false-value="">
                      <label for="sel_email_2"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Email" v-model="neptun.email"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="checkbox" style="margin: 0px">
                      <input :disabled="neptun.phone == ''" id="sel_phone_2" v-model="sel_phone" type="checkbox" true-value="neptun" false-value="">
                      <label for="sel_phone_2"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Telefon" v-model="neptun.phone"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="checkbox" style="margin: 0px">
                      <input :disabled="neptun.neptun_code == ''" id="sel_neptun_code_2" v-model="sel_neptun_code" type="checkbox" true-value="neptun" false-value="">
                      <label for="sel_neptun_code_2"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Neptun kód" v-model="neptun.neptun_code"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="checkbox" style="margin: 0px">
                      <input :disabled="neptun.orgware_id == ''" id="sel_orgware_id_2" v-model="sel_orgware_id" type="checkbox" true-value="neptun" false-value="">
                      <label for="sel_orgware_id_2"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Orgware" v-model="neptun.orgware_id"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="checkbox" style="margin: 0px">
                      <input :disabled="neptun.id_doc_id == ''" id="sel_id_doc_id_2" v-model="sel_id_doc_id" type="checkbox" true-value="neptun" false-value="">
                      <label for="sel_id_doc_id_2"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Szem. ig. szám" v-model="neptun.id_doc_id"></inputbox>
                </div>
              </div>
            </div>
            <div class="col-xs-4" style="background-color: #fdfdfd">
              <div class="row">
                <div class="col-xs-12">
                  <div class="panel-sub-heading">
                    <h4>AD</h4>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="checkbox" style="margin: 0px">
                      <input :disabled="orgware.name == ''" id="sel_name_3" v-model="sel_name" type="checkbox" true-value="orgware" false-value="">
                      <label for="sel_name_3"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Név" v-model="orgware.name"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="checkbox" style="margin: 0px">
                      <input :disabled="orgware.email == ''" id="sel_email_3" v-model="sel_email" type="checkbox" true-value="orgware" false-value="">
                      <label for="sel_email_3"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Email" v-model="orgware.email"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="checkbox" style="margin: 0px">
                      <input :disabled="orgware.phone == ''" id="sel_phone_3" v-model="sel_phone" type="checkbox" true-value="orgware" false-value="">
                      <label for="sel_phone_3"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Telefon" v-model="orgware.phone"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="checkbox" style="margin: 0px">
                      <input :disabled="orgware.neptun_code == ''" id="sel_neptun_code_3" v-model="sel_neptun_code" type="checkbox" true-value="orgware" false-value="">
                      <label for="sel_neptun_code_3"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Neptun kód" v-model="orgware.neptun_code"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="checkbox" style="margin: 0px">
                      <input :disabled="orgware.orgware_id == ''" id="sel_orgware_id_3" v-model="sel_orgware_id" type="checkbox" true-value="orgware" false-value="">
                      <label for="sel_orgware_id_3"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Orgware" v-model="orgware.orgware_id"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-1">
                  <div style="margin-top:29px" class="form-group">
                    <div class="checkbox" style="margin: 0px">
                      <input :disabled="orgware.id_doc_id == ''" id="sel_id_doc_id_3" v-model="sel_id_doc_id" type="checkbox" true-value="orgware" false-value="">
                      <label for="sel_id_doc_id_3"></label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-10">
                  <inputbox label="Szem. ig. szám" v-model="orgware.id_doc_id"></inputbox>
                </div>
              </div>
          </div>
        </div>
        <div class="modal-footer">
          <button v-on:click="hide" class="btn btn-large" type="button">Bezár</button>
          <button :disabled="loading || !oneSelected" v-on:click="insert" class="btn btn-primary btn-large" type="button"><i class="fa fa-level-down"></i>Kiválasztott adatok kitöltése</button>
        </div>
      </div>
      <div v-if="loading" class="modal-body">
        <svg class="preloader-svg" width="32" height="32" viewBox="0 0 66 66"><circle stroke="#dbdbdb" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle><circle class="preloader-svg-path" stroke="#666" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>
      </div>
    </div>`,
  computed: {
    oneSelected() {
      var s = false;
      var _this = this;

      ['sel_name', 'sel_email', 'sel_phone', 'sel_neptun_code', 'sel_orgware_id', 'sel_id_doc_id'].map((item) => {
        if (_this[item] != '') {
          s = true;
        }
      });

      return s;
    }
  },
  mounted() {
    var _this = this;

    this.loading = true;
    this.getShibData();
  },

  methods: {
    getShibData() {
      const _this = this;

      if (_this.user.mid != '') {
        _this.$root.ajax('fill_popup_search/mid', {
          method: 'POST',
          data: {
            mid: _this.user.mid
          },
          success: function(response) {
            if (response.items != undefined && response.items.length > 0) {
              var d = JSON.parse(response.items[0].id);
              _this.shib.name = d.name;
              _this.shib.email = d.email;
              _this.shib.phone = '';
              _this.shib.neptun_code = d.neptuncode;
              _this.shib.orgware_id = d.orgware_id;
              _this.shib.id_doc_id = d.idcardnumber;
            }
            _this.getNeptunData();
          }
        });
      } else {
        _this.getNeptunData();
      }
    },

    getNeptunData() {
      const _this = this;

      if (_this.user.neptun_code != '') {
        _this.$root.ajax('fill_popup_search/neptun', {
          method: 'POST',
          data: {
            q: _this.user.neptun_code
          },
          success: function(response) {
            if (response.items != undefined && response.items.length > 0) {
              var d = JSON.parse(response.items[0].id);
              _this.neptun.name = d.name;
              _this.neptun.email = d.email;
              _this.neptun.phone = d.phone;
              _this.neptun.neptun_code = d.neptuncode;
              _this.neptun.orgware_id = d.orgware_id == undefined ? '' : d.orgware_id;
              _this.neptun.id_doc_id = d.idcardnumber;
            }
            _this.getOrgwareData();
          }
        });
      } else {
        _this.getOrgwareData();
      }
    },

    getOrgwareData() {
      const _this = this;

      if (_this.user.orgware_id != '') {
        _this.$root.ajax('fill_popup_search/orgware', {
          method: 'POST',
          data: {
            q: _this.user.orgware_id
          },
          success: function(response) {
            if (response.items != undefined && response.items.length > 0) {
              var d = JSON.parse(response.items[0].id);
              _this.orgware.name = d.name;
              _this.orgware.email = d.email;
              _this.orgware.phone = d.phone;
              _this.orgware.neptun_code = d.neptuncode;
              _this.orgware.orgware_id = d.orgware_id;
              _this.orgware.id_doc_id = '';
            }
            _this.loading = false;
          }
        });
      } else {
        _this.loading = false;
      }
    },

    insert: function() {
      var d = {};

      if (this.sel_name != '') {
        d.name = this[this.sel_name].name;
      }

      if (this.sel_email != '') {
        d.email = this[this.sel_email].email;
      }

      if (this.sel_phone != '') {
        d.phone = this[this.sel_phone].phone;
      }

      if (this.sel_neptun_code != '') {
        d.neptun_code = this[this.sel_neptun_code].neptun_code;
      }

      if (this.sel_orgware_id != '') {
        d.orgware_id = this[this.sel_orgware_id].orgware_id;
      }

      if (this.sel_id_doc_id != '') {
        d.id_doc_id = this[this.sel_id_doc_id].id_doc_id;
      }

      this.$emit('onBtnClick', d);
      this.hide();
    },
    hide: function() {
      this.hidepopup();
    }
  }
});

export default {
  components: {
    tplheader,
    tplLeftPanel
  },
  data: function() {
    return {
      form: {
        user: {},
        id_doc_type: [],
        shib_users: {
          items: [],
          selected: 0
        },
        ad_users: {
          items: [],
          selected: 0
        }
      },
      errors: [],
      video: '',
      canvas: '',
      ctx: '',
      localMediaStream: '',
      cameraOn: false,
      crop_popup: false,
      crop_coords: {
        x: 0,
        y: 0,
        w: 0,
        h: 0
      },
      video_canvas_w: 640,
      video_canvas_h: 480,
      video_div_w: 640,
      video_div_h: 480,
      fill_popup: false,
      compare_popup: false,
      is_save: false,
      takePictureEnabled: true
    }
  },
  computed: {
    cameraTurnOnOffBtnTitle: function() {
      return this.cameraOn ? 'Kamera lekapcsolása' : 'Kamera bekapcsolása'
    },
    cropPopupWidth: function() {
      return 900 + 30;
    },
    previewImage: function() {
      return this.form.user.new_photo != '' ? this.form.user.new_photo : this.form.user.photo;
    },
    cardsShow: function() {
      if (typeof this.form.user.cards != "undefined") {
        return this.form.user.cards.length > 0 ? true : false;
      } else {
        return false;
      }
    }
  },
  mounted: function() {
    var _this = this;

    this.video = document.querySelector('video');
    this.canvas = document.querySelector('canvas');
    this.ctx = this.canvas.getContext('2d');
    this.ctx.webkitImageSmoothingEnabled = false;
    this.ctx.mozImageSmoothingEnabled = false;
    this.ctx.imageSmoothingEnabled = false;
    this.localMediaStream = null;

    this.video.addEventListener("loadedmetadata", function() {
      // Canvas mérete a videó mérete
      _this.video_canvas_w = _this.video.videoWidth;
      _this.video_canvas_h = _this.video.videoHeight;

      //if (_this.video_canvas_w < 900 || _this.video_canvas_h < 1080)
        //_this.takePictureEnabled = false;

      // Külső div arányosan beállítva a videó méretéhez
      _this.video_div_w = 640;
      _this.video_div_h = _this.video_div_w * (_this.video_canvas_h / _this.video_canvas_w);

    }, false);

    this.$root.ajax('card_owner/edit/' + (this.$route.query.id != undefined ? this.$route.query.id : 0), {
      success: function(response) {
        response.user.password_ = response.user.password;
        _this.form.user = response.user;
        _this.form.id_doc_type = response.id_doc_type;
        _this.form.shib_users = response.shib_users;
        _this.form.ad_users = response.ad_users;
        _this.form.user.phone = _this.form.user.phone.replace(/[#]/g, '');
      }
    });
  },
  watch: {
    crop_popup: function(new_val, old_val) {
      var _this = this;

      if (new_val) {
        var interval = setInterval(function() {
          if ($('#crop-image').length > 0) {
            clearInterval(interval);

            $('#cropmodal').css({'top': $(window).scrollTop()});

            $("#crop-image").Jcrop({
              boxWidth: 900,
              boxHeight: 1080,
              aspectRatio: 0.83333,
              setSelect: [0, 0, 900, 1080],
              minSize: [700, 840],
              trueSize: [_this.form.user.photo_w, _this.form.user.photo_h],
              onChange: function(coords) {
                var rx = 900 / coords.w;
                var ry = 1080 / coords.h;
              },
              onSelect: function(c) {
                _this.crop_coords.x = c.x;
                _this.crop_coords.y = c.y;
                _this.crop_coords.w = c.w;
                _this.crop_coords.h = c.h;
              }
            });
          }
        }, 100);
      }
    }
  },
  methods: {
    fillPopupBtnClick(d) {
      const _this = this;

      Object.keys(d).forEach(function(key) {
        _this.form.user[key] = d[key];
        if (key == 'id_doc_id') {
          _this.form.user.id_doc_type_id = 1;
          _this.form.id_doc_type.selected = 1;
        }
      });
    },

    // Csak akkor látszódhat a kártya szerkesztés gomb, ha az adminnak van joga a kártya elsődleges jogához
    cardEditButtonShow: function(card_rules) {
      var _this = this;
      var visible = false;

      // Nincs beállítva az adminnak kártya jog, megjelenik a gomb
      if (this.$root.user.card_rules == undefined) {
        visible = true;

      } else {
        if (card_rules != undefined) {
          card_rules.map(function(rule) {
            // A kártya elsődleges joga van vizsgálva
            if (rule.primaryc == 1 && rule.public == 1) {
              visible = _this.$root.checkCardRule(rule.id);
            }
          });
        }
      }

      return visible;
    },

    modifyAccountExpires: function() {
      var _this = this;
      var new_date;

      // Aktuális idő nagyobb, mint a lejárat, akkor az aktuális időponttól módosítja a dátumot
      if (moment().isAfter(this.form.user.account_expires)) {
        new_date = moment().add(1, 'years');

      // különben a lejárati dátumhoz ad hozzá 1 évet
      } else {
        new_date = moment(this.form.user.account_expires).add(1, 'years');
      }

      swal({
        title: "Szeretné a lejárati időt meghosszabítani?",
        text: "Az új hosszabított idő: " + new_date.format('YYYY-MM-DD HH:mm:SS'),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Igen",
        cancelButtonText: "Nem",
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: false
      }, function(isConfirm) {
        if (isConfirm) {
          _this.$root.ajax('cardowner/modify_account_expires', {
            method: 'POST',
            data: {
              owner_id: _this.form.user.id,
              date: new_date.format('YYYY-MM-DD HH:mm:SS')
            },
            success: function(response) {
              if (response.error) {
                swal('Figyelem', response.msg, 'error');
              } else {
                _this.$router.push({path: '/card_owner/edit/', query: { id: _this.form.user.id }});
                location.reload();
              }
            }
          });
        }
      });

    },

    fillUserData: function(name, email, phone, neptun_code, orgware_id, id_doc_id, id_doc_type_id, mid, photo) {
      this.form.user.name = name;
      this.form.user.email = email;
      this.form.user.phone = phone;
      this.form.user.neptun_code = neptun_code;
      this.form.user.orgware_id = orgware_id;
      this.form.user.photo = photo;
      this.form.user.mid = mid;
      this.form.user.id_doc_id = id_doc_id;

      if (id_doc_id != '') {
        this.form.id_doc_type = {
          items: this.form.id_doc_type.items,
          selected: id_doc_type_id
        };
      }

      // Legördülő listában jelenjen meg a kiválasztott címtáras felhasználó
      if (mid != '' && name != '') {
        this.form.shib_users = {
          items: [
            {
              label: name,
              value: mid
            }
          ],
          selected: mid
        };
      }
    },
    setUserID: function(id) {
      this.form.user.id = id;
    },
    showFillPopup: function() {
      this.fill_popup = true;
    },

    hideFillPopup: function() {
      this.fill_popup = false;
    },

    showComparePopup: function() {
      this.compare_popup = true;
    },

    hideComparePopup: function() {
      this.compare_popup = false;
    },

    openCropPopupToCutOrigPhoto: function() {
      this.form.user.new_photo = this.form.user.photo;
      this.showCropPopup();
    },

    cardRulesShow: function(card) {
      return card.rules.length > 0 ? true : false;
    },
    crop: function() {
      var _this = this;

      this.$root.ajax('card_owner/crop_photo', {
        method: 'POST',
        data: {
          base64: _this.form.user.new_photo,
          x: _this.crop_coords.x,
          y: _this.crop_coords.y,
          w: Math.ceil(_this.crop_coords.w),
          h: Math.ceil(_this.crop_coords.h)
        },
        success: function(response) {
          if (response.base64 != undefined)
            _this.form.user.new_photo = response.base64;

          _this.hideCropPopup();
        }
      });
    },
    showCropPopup: function() {
      this.crop_popup = true;
    },
    hideCropPopup: function() {
      this.crop_popup = false;
    },
    hideCropPopupClick: function() {
      this.form.user.new_photo = "";
      this.form.user.photo_w = 0;
      this.form.user.photo_h = 0;
      this.hideCropPopup();
    },
    hasGetUserMedia: function() {
      return !!(navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mediaDevices ||
                navigator.mozGetUserMedia || navigator.msGetUserMedia);
    },
    turnOnOffCamera: function() {
      if (this.cameraOn) {
        this.turnOffCamera();
        this.ctx.clearRect(0, 0, this.video_canvas_w, this.video_canvas_h);
      } else {
        if (this.hasGetUserMedia()) {
          this.turnOnCamera();
        } else {
          alert('Böngésző nem támogatja a kamerát');
        }
      }
    },
    turnOnCamera: function() {
      var _this = this;

      this.cameraOn = true;

      navigator.getUserMedia = ( navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia);

      navigator.getUserMedia({video: {width: { ideal: 1920 }, height: { ideal: 1080 }}}, function(stream) {
        _this.video.srcObject = stream;
        _this.localMediaStream = stream;

      }, _this.cameraErrorCallback);
    },
    cameraErrorCallback: function(e) {
      console.log(e);
    },
    turnOffCamera: function() {
      this.cameraOn = false;
      this.video.pause();
      this.video.srcObject = new MediaStream();
    },
    takePicture: function() {
      if (this.localMediaStream) {
        this.ctx.drawImage(this.video, 0, 0, this.video_canvas_w, this.video_canvas_h);
        this.form.user.new_photo = this.canvas.toDataURL("image/png");
        this.form.user.photo_w = this.video_canvas_w;
        this.form.user.photo_h = this.video_canvas_h;
        this.showCropPopup();
      }
    },
    uploadPhotoClick: function() {
      $('#upload_file').trigger('click');
    },
    uploadPhoto: function(e) {
      var allowed_types = new Array('image/jpg','image/jpeg');
      var file = e.target.files[0];

      if ($.inArray(file.type, allowed_types) == -1 || file.length === 0) {
        alert("Csak jpg fájl feltöltés engedélyezett.");
        return;
      }

      $.fn.spin.presets.preloader = {lines:13, length:0, width:3, radius:10, scale:.75, corners:1, opacity:.25, speed:1};
      $('#upload_photo_btn').addClass('with-preloader');
      $('#upload_photo_btn').spin('preloader');

      var reader = new FileReader();
      var _this = this;

      reader.onload = function(e) {
        _this.$root.ajax('card_owner/upload_photo', {
          method: 'POST',
          data: {
            base64: e.target.result
          },
          success: function(response) {
            $('#upload_photo_btn').spin(false).removeClass('with-preloader');

            if (response.error) {
              swal('Figyelem', response.msg, 'error');

            } else {
              if (response.base64 != undefined) {
                _this.form.user.new_photo = response.base64;
                _this.form.user.photo_w = response.width;
                _this.form.user.photo_h = response.height;
                _this.showCropPopup();
              }
            }
          }
        });
      };
      reader.readAsDataURL(file);
    },
    shibUserChange: function() {
      var _this = this;

      this.$root.ajax('user/getShibUser/' + this.form.shib_users.selected + '/mid', {
        success: function(response) {
//          _this.form.user.email = response.user.email;
//          _this.form.user.name = response.user.name;
//          _this.form.user.neptun_code = response.user.neptun_code;
//          _this.form.user.orgware_id = response.user.orgware_id;
//          _this.form.user.phone = '';
          _this.form.user.mid = response.user.mid;
//          _this.form.user.photo = response.user.photo;

        }
      });
    },

    ADUserChange: function() {
      const _this = this;

      this.$root.ajax('get_ad_user/' + this.form.ad_users.selected, {
        success: function(response) {
          if (response.ad_username != false) {
            _this.form.user.ad_username = response.ad_user.samaccountname;
            _this.form.user.ad_object_sid = response.ad_user.objectsid;
          }
        }
      });
    },

    save: function () {
      var _this = this;
      //this.is_save = true;

      this.$root.ajax('card_owner/save', {
        method: 'POST',
        data: this.form,
        success: function(response) {
          _this.is_save = false;

          if (response.errors.length > 0) {
            _this.errors = response.errors;
          } else {
            _this.$router.push({path: '/card_owners/list'});
          }
        }
      });
    },

    showADSelectbox() {
      var show = false;

      if (this.form.user.cards != undefined) {
        this.form.user.cards.map((card) => {
          if (card.status == 'Aktív') {
            show = true;
          }
        });
      }

      return show;
    },

    savePreCheck: function () {
      var _this = this;
      this.errors = [];
      this.is_save = true;

      this.$root.ajax('card_owner/save_pre_check', {
        method: 'POST',
        data: this.form,
        success: function(response) {
          _this.is_save = false;

          if (response.errors.length > 0) {
            _this.errors = response.errors;

          } else {
            if (_this.form.user.id == 0)
              _this.showComparePopup();
            else
              _this.save();
          }
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// cardowner.vue?3f4298a4